import { useNavigate, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { TasksTaskDetail } from "./TasksTaskDetail";

export function TasksTaskPage() {
  const navigate = useNavigate();
  const { taskId } = useParams();

  if (!taskId) {
    navigate("/tasks", { replace: true });
    return null;
  }

  return (
    <div className="min-h-screen bg-brand-gray px-4 py-6 text-brand-blue">
      <div className="mx-auto max-w-2xl">
        <button
          type="button"
          onClick={() => navigate("/tasks", { replace: true })}
          className="inline-flex items-center gap-2 text-sm font-semibold text-brand-blue/80"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to list
        </button>

        <p className="mt-6 font-display text-2xl font-bold">Task</p>
        <p className="mt-1 text-sm text-brand-blue/70">View details and manage checklist.</p>

        <div className="mt-6 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-black/5">
          <TasksTaskDetail
            taskId={taskId}
            mode="manual"
            onDeleted={() => navigate("/tasks", { replace: true })}
            onUpdated={() => {
              // list page reload isn't required; we keep this page self-contained
            }}
          />
        </div>
      </div>
    </div>
  );
}

